// SPH multilingual search placeholders: choose the longest text that truly fits.
// Search requests, product matches, and form behavior are not modified.
const inputSelector = 'input[data-sph-search-placeholder]';
const headerSelector = '[data-sph-header-placeholder]';
const observed = new WeakSet();
const measurer = document.createElement('canvas').getContext('2d');

function textOptions(element) {
  const data = element.dataset;
  return [
    data.sphPlaceholderDesktop,
    data.sphPlaceholderMobile,
    data.sphPlaceholderSmall,
    data.sphPlaceholderFallback,
  ].filter((value, i, list) => Boolean(value) && list.indexOf(value) === i);
}

function fitsInput(input, text) {
  if (!measurer || input.clientWidth === 0) return false;
  const style = getComputedStyle(input);
  measurer.font = style.font || `${style.fontWeight} ${style.fontSize} ${style.fontFamily}`;
  const letterSpacing = parseFloat(style.letterSpacing) || 0;
  const width = measurer.measureText(text).width
    + Math.max(0, text.length - 1) * letterSpacing;
  const left = parseFloat(style.paddingLeft) || 0;
  const right = parseFloat(style.paddingRight) || 0;
  // Reserve room for the browser search field controls and a visual margin.
  return width + 20 <= input.clientWidth - left - right;
}

function updateInput(input) {
  const options = textOptions(input);
  if (options.length === 0) return;
  const chosen = options.find((candidate) => fitsInput(input, candidate))
    || options.at(-1);
  if (input.placeholder !== chosen) input.placeholder = chosen;
}

function updateHeaderText(span) {
  const options = textOptions(span);
  if (options.length === 0 || span.clientWidth === 0) return;
  for (const text of options) {
    if (span.textContent !== text) span.textContent = text;
    // scrollWidth detects overflow even when CSS hides the excess with ellipsis.
    if (span.scrollWidth <= span.clientWidth + 1) return;
  }
}

const resizeObserver = typeof ResizeObserver === 'undefined' ? null
  : new ResizeObserver(() => updateAll());

function observeWidths(root = document) {
  if (!resizeObserver) return;
  for (const input of root.querySelectorAll(inputSelector)) {
    if (observed.has(input)) continue;
    observed.add(input);
    resizeObserver.observe(input);
  }
  for (const span of root.querySelectorAll(headerSelector)) {
    const button = span.closest('.fake-search-input__button');
    if (!button || observed.has(button)) continue;
    observed.add(button);
    resizeObserver.observe(button);
  }
}

function updateAll() {
  for (const input of document.querySelectorAll(inputSelector)) updateInput(input);
  for (const span of document.querySelectorAll(headerSelector)) updateHeaderText(span);
  observeWidths();
}

function initSearchPlaceholders() {
  updateAll();
  if (!resizeObserver) window.addEventListener('resize', updateAll);
  document.addEventListener('shopify:section:load', updateAll);
  document.fonts?.ready?.then(updateAll);

  // Some theme sections and predictive-search elements are injected after load.
  const observer = new MutationObserver((mutations) => {
    const selector = inputSelector + ', ' + headerSelector;
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(selector) || node.querySelector?.(selector)) {
          updateAll();
          return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchPlaceholders, { once: true });
} else {
  initSearchPlaceholders();
}
